"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var centerBySize_1 = __importDefault(require("./centerBySize"));
var isScreenSmall_1 = __importDefault(require("../helpers/isScreenSmall"));
var rtlMap = {
    "start-top": "end-top",
    start: "end",
    "start-bottom": "end-bottom",
    "end-top": "start-top",
    end: "start",
    "end-bottom": "start-bottom",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-end": "bottom-start",
    "bottom-start": "bottom-end",
};
/**
 * Calculate styles for the current position
 */
var calculatePosition = function (originBounds, targetBounds, options) {
    var _a, _b, _c, _d, _e;
    var passedPosition = options.position, rtl = options.rtl, mobileFallback = options.mobileFallback, zIndex = options.zIndex;
    var left = 0;
    var top = 0;
    var position = passedPosition;
    if (rtl)
        position = rtlMap[position] || position;
    switch (position) {
        case "bottom":
        case "top":
            left =
                (0, centerBySize_1.default)(originBounds.width, targetBounds.width) +
                    originBounds.left;
            break;
        case "start-top":
        case "start":
        case "start-bottom":
            left = originBounds.left - targetBounds.width;
            break;
        case "end-top":
        case "end":
        case "end-bottom":
            left = originBounds.right;
            break;
        case "top-start":
        case "bottom-start":
        case "bottom-stretch":
            left = originBounds.left;
            break;
        case "top-end":
        case "bottom-end":
            left = originBounds.right - targetBounds.width;
            break;
        default:
            break;
    }
    switch (position) {
        case "top-start":
        case "top":
        case "top-end":
            top = originBounds.top - targetBounds.height;
            break;
        case "bottom-start":
        case "bottom":
        case "bottom-end":
        case "bottom-stretch":
            top = originBounds.bottom;
            break;
        case "start-top":
        case "end-top":
            top = originBounds.top;
            break;
        case "start-bottom":
        case "end-bottom":
            top = originBounds.bottom - targetBounds.height;
            break;
        case "start":
        case "end":
            top =
                (0, centerBySize_1.default)(originBounds.height, targetBounds.height) +
                    originBounds.top;
            break;
        default:
            break;
    }
    if (options.container) {
        top = Math.round(top + (options.container.scrollTop || 0) + (((_a = options.compensation) === null || _a === void 0 ? void 0 : _a.y) || 0));
        left = Math.round(left +
            (options.container.scrollLeft || 0) +
            (((_b = options.compensation) === null || _b === void 0 ? void 0 : _b.x) || 0));
    }
    else {
        top = Math.round(top + (window.pageYOffset || 0) + (((_c = options.compensation) === null || _c === void 0 ? void 0 : _c.y) || 0));
        left = Math.round(left + (window.pageXOffset || 0) + (((_d = options.compensation) === null || _d === void 0 ? void 0 : _d.x) || 0));
    }
    var containerWidth = ((_e = options === null || options === void 0 ? void 0 : options.container) === null || _e === void 0 ? void 0 : _e.clientWidth) || window.innerWidth;
    var widthStyle = Math.ceil(targetBounds.width);
    var height = Math.ceil(targetBounds.height);
    var isFallback = mobileFallback &&
        (0, isScreenSmall_1.default)() &&
        (targetBounds.left < constants_1.SCREEN_OFFSET ||
            targetBounds.right > containerWidth - constants_1.SCREEN_OFFSET);
    if (position === "bottom-stretch") {
        widthStyle = originBounds.width;
    }
    else if (isFallback) {
        left = constants_1.SCREEN_OFFSET;
        widthStyle = containerWidth - constants_1.SCREEN_OFFSET * 2;
    }
    var styles = {
        left: left,
        top: top,
        width: widthStyle,
        height: height,
        zIndex: zIndex,
    };
    return { styles: styles, position: position };
};
exports.default = calculatePosition;
